import { render, staticRenderFns } from "./ImpuestoHistorical.vue?vue&type=template&id=54eccc62&scoped=true"
import script from "./ImpuestoHistorical.vue?vue&type=script&lang=js"
export * from "./ImpuestoHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eccc62",
  null
  
)

export default component.exports